module.exports = __webpack_public_path__ + "static/media/water-over-rocks.c5d385d5.jpg";